module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-info btn-lg btn-menu",
    attrs: {
      "to": "/users"
    }
  }, [_c('i', {
    staticClass: "fa fa-address-card"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('User Shop')))])])], 1), (_vm.isSystemManagement || _vm.isHumanStaff || _vm.isMachineOrderAdmin) ? _c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-warning btn-lg btn-menu",
    attrs: {
      "to": "/master"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Master Manage')))])])], 1) : _vm._e(), (_vm.isSystemManagement) ? _c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-violet btn-lg btn-menu",
    attrs: {
      "to": "/access"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('ACCESS')))])])], 1) : _vm._e(), (_vm.isSystemManagement) ? _c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-lg btn-menu",
    attrs: {
      "to": "/proposes"
    }
  }, [(_vm.proposeTotalCount > 0) ? _c('span', {
    staticClass: "badge pull-right margin-right"
  }, [_vm._v(_vm._s(_vm.proposeTotalCount) + " 件")]) : _vm._e(), _c('i', {
    staticClass: "fa fa-lightbulb-o",
    class: _vm.proposeTotalCount > 0 ? 'ml50' : ''
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Propose')))])])], 1) : _vm._e(), (_vm.isSystemManagement || _vm.isShopMaster) ? _c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-success btn-lg btn-menu",
    attrs: {
      "to": "/morals"
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Moral')))])])], 1) : _vm._e(), (_vm.isSystemManagement || (_vm.isShopMaster || _vm.isOfficer || _vm.isHarassment)) ? _c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-lime btn-lg btn-menu",
    attrs: {
      "to": "/message"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Message')))])])], 1) : _vm._e(), (_vm.isSystemManagement) ? _c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-danger btn-lg btn-menu",
    attrs: {
      "to": "/shop_managers"
    }
  }, [_c('i', {
    staticClass: "fa fa-user-circle"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Shop Manager')))])])], 1) : _vm._e(), (_vm.isSystemManagement) ? _c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-olive btn-lg btn-menu",
    attrs: {
      "to": "/human_staffs"
    }
  }, [_c('i', {
    staticClass: "fa fa-smile-o"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Human Staff')))])])], 1) : _vm._e(), (_vm.isSystemManagement || _vm.isShopMaster) ? _c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-teal btn-lg btn-menu",
    attrs: {
      "to": {
        path: _vm.getShiftCreatorUrl
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user-plus"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Shift Creator')))])])], 1) : _vm._e(), (_vm.isMagazineManager || _vm.isHumanStaff) ? _c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-warning btn-lg btn-menu",
    attrs: {
      "to": "/magazines"
    }
  }, [_c('i', {
    staticClass: "fa fa-newspaper-o"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Magazine')))])])], 1) : _vm._e(), (_vm.isShiftCreator || _vm.isClerk || _vm.isShopMaster) ? _c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-violet btn-lg btn-menu",
    attrs: {
      "to": "/shift_manage"
    }
  }, [_c('i', {
    staticClass: "fa fa-newspaper-o"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('ShiftManage')))])])], 1) : _vm._e(), (_vm.isShopMaster || _vm.isClerk || _vm.isSystemManagement) ? _c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-lg btn-menu",
    attrs: {
      "to": _vm.willmustPath()
    }
  }, [_c('i', {
    staticClass: "fa fa-hand-rock-o"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Will Must')))])])], 1) : _vm._e(), (_vm.isShopMaster || _vm.isClerk || _vm.isSystemManagement) ? _c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-info btn-lg btn-menu",
    attrs: {
      "to": "/document_renewals"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Document Renewal')))])])], 1) : _vm._e(), (_vm.canManagePayroll) ? _c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-success btn-lg btn-menu",
    attrs: {
      "to": "/payroll_documents"
    }
  }, [_c('i', {
    staticClass: "fa fa-jpy"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Payroll')))])])], 1) : _vm._e(), (_vm.isHumanStaff) ? _c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-violet btn-lg btn-menu",
    attrs: {
      "to": "/referral"
    }
  }, [_c('i', {
    staticClass: "fa fa-handshake-o"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Referral')))])])], 1) : _vm._e(), (_vm.isSystemManagement || _vm.isHumanStaff) ? _c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-success btn-lg btn-menu",
    attrs: {
      "to": "/stepup"
    }
  }, [_c('i', {
    staticClass: "fa fa-line-chart"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Step Up')))])])], 1) : _vm._e(), (_vm.isSystemManagement || _vm.isHumanStaff || _vm.canExportEsMycard) ? _c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-olive btn-lg btn-menu",
    attrs: {
      "to": "/es_mycard_result"
    }
  }, [_c('i', {
    staticClass: "fa fa-child"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Es Mycard')))])])], 1) : _vm._e(), (_vm.isSystemManagement) ? _c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-lg btn-menu",
    attrs: {
      "to": "/company_notice"
    }
  }, [_c('i', {
    staticClass: "fa fa-bell"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Company Notice')))])])], 1) : _vm._e(), (_vm.isSystemManagement || _vm.isManagementDept) ? _c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-info btn-lg btn-menu",
    attrs: {
      "to": "/stock"
    }
  }, [_c('i', {
    staticClass: "fa fa-cart-plus"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Stock')))])])], 1) : _vm._e(), (_vm.isSystemManagement || _vm.isHumanStaff) ? _c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-success btn-lg btn-menu",
    attrs: {
      "to": "/evaluate_question"
    }
  }, [_c('i', {
    staticClass: "fa fa-line-chart"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Evaluate Questions')))])])], 1) : _vm._e(), (_vm.isSystemManagement || _vm.isHumanStaff || _vm.isShopMaster || _vm.isShopManager) ? _c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-success btn-lg btn-menu",
    attrs: {
      "to": "/service_question"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-square"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Service Questions')))])])], 1) : _vm._e(), (_vm.isSystemManagement || _vm.isShopMaster) ? _c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-danger btn-lg btn-menu",
    attrs: {
      "to": "/safety_confirmations"
    }
  }, [_c('i', {
    staticClass: "fa fa-bullhorn"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Safety Confirmation')))])])], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-44f78b96!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/home.pug
// module id = 837
// module chunks = 1